import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type { IntegrationHttpApiRequestOptions } from './types';
import { IntegrationsHttpRequestData } from './types';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsHttpApiService extends HttpApiService {
  constructor() {
    const httpRequestData = inject(IntegrationsHttpRequestData);
    super(httpRequestData);
  }

  public get<R = any>(
    path: string,
    params?: any,
    options?: IntegrationHttpApiRequestOptions,
  ): Observable<R> {
    return super.get(path, params, options);
  }

  public post<R = any>(
    path: string,
    params?: any,
    body?: object | null,
    options?: IntegrationHttpApiRequestOptions,
    progressEmitter: string | null = null,
  ): Observable<R> {
    return super.post(path, params, body, options, progressEmitter);
  }

  public put<R = any>(
    path: string,
    params?: any,
    body?: object,
    options?: IntegrationHttpApiRequestOptions,
  ): Observable<R> {
    return super.put(path, params, body, options);
  }

  public patch<R = any>(
    path: string,
    params?: any,
    body?: object | null,
    options?: IntegrationHttpApiRequestOptions,
  ): Observable<R> {
    return super.patch(path, params, body, options);
  }

  public delete<R = any>(
    path: string,
    params?: any,
    options?: IntegrationHttpApiRequestOptions,
  ): Observable<R> {
    return super.delete(path, params, options);
  }
}
